import { render } from "./TheSheetMenuBottom.vue?vue&type=template&id=3692a2a6&scoped=true"
import script from "./TheSheetMenuBottom.vue?vue&type=script&lang=js"
export * from "./TheSheetMenuBottom.vue?vue&type=script&lang=js"

import "./TheSheetMenuBottom.vue?vue&type=style&index=0&id=3692a2a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3692a2a6"

export default script